import React from "react";
import {Typography} from "@mui/material";

import {buildHealthIndicatorIcon, buildSessionHealthColor} from "../../../helpers/HealthIndicatorBuilder";
import {CenteredBox, ColoredAvatar} from "../../themes/styled";

export default function CohostsAddedHealth({session, state}) {

    const backgroundColor = buildSessionHealthColor[state];
    const icon = buildHealthIndicatorIcon("cohosts-added");

    return (
      <CenteredBox>
          <ColoredAvatar background={backgroundColor}>{icon}</ColoredAvatar>
          <Typography variant="body2">Co-hosts added</Typography>
      </CenteredBox>
    );
}